import React from 'react';
import Header from './component/Header';
import Form from './component/Form';
import ListRecipes from './component/ListRecipes';
import CategoriesProvider from './context/CategoriesContext';
import RecipeProvider from './context/RecipesContext';
import ModalProvider from './context/ModalContext'
function App() {
  return (
    <CategoriesProvider>
      <RecipeProvider>
        <ModalProvider>
          <Header />
          <div className="container mt-5">
            <div className="row">
              <Form />
            </div>
            <ListRecipes />
          </div>
        </ModalProvider>
      </RecipeProvider>
    </CategoriesProvider>
  );
}

export default App;
